module.exports = __webpack_public_path__ + "static/media/logo.dbb3a8e1.png";